import client from './client';

export function getPublicEndpoints() {
  return client.get('/api/public/endpoints', { skipAuth: true });
}

export function getVersion() {
  return client.get('/api/version', { skipAuth: true });
}

export function getPublicIncidents() {
  return client.get('/api/public/incidents', { skipAuth: true });
}

export function getPublicIncidentById(incidentId) {
  return client.get(`/api/public/incidents/${incidentId}`, { skipAuth: true });
}

export function getPublicMaintenance() {
  return client.get('/api/public/maintenance', { skipAuth: true });
}

export function getMaintenanceHistory(days = 90) {
  return client.get('/api/public/maintenance/history', { params: { days }, skipAuth: true });
}

export function getPublicEndpointById(endpointId) {
  return client.get(`/api/public/endpoints/${endpointId}`, { skipAuth: true });
}

export function getEndpointHistory(endpointId, days) {
  return client.get(`/api/public/endpoints/${endpointId}/history`, {
    params: { days },
    skipAuth: true,
  });
}

export function getAllEndpointsHistory(days = 90) {
  return client.get('/api/public/endpoints/history', {
    params: { days },
    skipAuth: true,
  });
}

export function getEndpointUptime(endpointId, days) {
  return client.get(`/api/public/endpoints/${endpointId}/uptime`, {
    params: { days },
    skipAuth: true,
  });
}

export function getEndpointResponseTimes(endpointId, params) {
  return client.get(`/api/public/endpoints/${endpointId}/response-times`, {
    params,
    skipAuth: true,
  });
}

export function getEndpointShardEvents(endpointId, days) {
  return client.get(`/api/public/endpoints/${endpointId}/shard-events`, {
    params: { days },
    skipAuth: true,
  });
}
